import { useState } from "react";
import { useStore } from "../../store/store";
import { centorMagnetColors } from "./defaults";
import { SelectChangeEvent } from "@mui/material";
import { useRequiredMsgs } from "../../store/requiredMsgs";

function useMagnetCatchSelector() {
  const addToQuote = useStore((state) => state.addToQuote);

  const magnetCatch = useStore((state) => state.quote.magnetCatch);

  const magnetCatchColor = useStore((state) => state.quote.magnetCatchColor);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleChangeColor = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;

    if (!value) {
      addToQuote({ magnetCatchColor: "" });
    } else {
      addToQuote({ magnetCatchColor: value });
      if (findRequired("Magnet Finish")) removeRequired("Magnet Finish");
    }
  };

  const handleClick = (label: string) => {
    const checked = checkMark(label);

    if (checked) {
      return addToQuote({magnetCatch: "", magnetCatchColor: ""})
    };

    let update = {
      magnetCatch: label,
    };
    if (magnetCatchColor) {
      const colorObj = {
        "Stainless Steel": "Satin Nickel",
        "Satin Nickel": "Stainless Steel",
        Black: "Black",
      };
      update["magnetCatchColor"] = colorObj[magnetCatchColor];
    }
    addToQuote(update);
  };

  const variant = (label: string) =>
    label === magnetCatch ? "filled" : "outlined";

  const checkMark = (label: string) => label === magnetCatch;

  const colorOptions =
    magnetCatch === "Add Centor Magnet Catch"
      ? centorMagnetColors
      : [];

  const imgSrc =
    magnetCatch?.includes("Centor") && magnetCatchColor
      ? `Centor_Magnet_Catch/${magnetCatchColor.replace(
          " ",
          "_"
        )}_Centor_Magnet.jpg`
      : "";

  return {
    handleChangeColor,
    variant,
    checkMark,
    imgSrc,
    handleClick,
    magnetCatchColor,
    colorOptions,
    magnetCatch,
    open,
    handleOpen,
    handleClose
  };
}

export default useMagnetCatchSelector;
